// extracted by mini-css-extract-plugin
export default {"media":"Media_media__8zkIQ","media--mobile":"Media_media--mobile__AsV1C"};